import { StaticChart } from "@quillsql/react"
import clsx from "clsx"

import { Card, Label } from "@atoms"

import styles from "./ReportChartCard.module.scss"
import { ReportChartCardProps } from "./ReportChartCard.types"

export default function ReportChartCard(props: ReportChartCardProps) {
    const { reportId, reportName, chartType, showLegend, onClick } = props

    const isMetric = chartType === "metric" || chartType === "number"
    const isTable = chartType === "table"

    return (
        <Card className={clsx(styles.card, { [styles.tableCard]: isTable })} onClick={onClick}>
            <Label label={reportName} variant="default" />
            <div className={clsx(styles.chart, { [styles.metricChart]: isMetric, [styles.tableChart]: isTable })}>
                <StaticChart reportId={reportId} showLegend={showLegend} />
            </div>
        </Card>
    )
}
